(() => {
  if (customElements.get('cc-purchase-options')) return;
  class PurchaseOptions extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', (event) => {
        const panel = event.target.closest('[data-purchase-variant]');
        if (!panel) return;
        this.updatePanel(panel);
        if (event.target.type === 'radio') {
          panel.querySelector('[data-purchase-plan]')?.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }, {signal: this.controller.signal});
      this.syncVariant({id: this.dataset.variantId});
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    syncVariant(variant) {
      const previous = this.querySelector('[data-purchase-variant]:not([hidden])');
      const oldPlan = previous?.querySelector('[data-purchase-plan]');
      const subscribed = previous?.querySelector('input[value="subscribe"]')?.checked;
      this.querySelectorAll('[data-purchase-variant]').forEach((panel) => {
        const active = panel.dataset.purchaseVariant === String(variant?.id);
        panel.hidden = !active || !panel.querySelector('[data-purchase-plan]');
        if (active && previous && panel !== previous) {
          const radio = panel.querySelector(`input[value="${subscribed || panel.dataset.required === 'true' ? 'subscribe' : 'once'}"]`);
          if (radio) radio.checked = true;
          const select = panel.querySelector('[data-purchase-plan]');
          if (select && oldPlan && Array.from(select.options).some((o) => o.value === oldPlan.value)) select.value = oldPlan.value;
        }
        this.updatePanel(panel);
      });
      this.hidden = !this.querySelector('[data-purchase-variant]:not([hidden])');
    }
    updatePanel(panel) {
      const select = panel.querySelector('[data-purchase-plan]');
      if (!select) return;
      const subscribed = panel.querySelector('input[value="subscribe"]').checked;
      select.disabled = panel.hidden || !subscribed;
      panel.querySelector('.cc-purchase__details').hidden = !subscribed;
      const option = select.selectedOptions[0];
      const price = panel.querySelector('[data-purchase-price]');
      price.textContent = option.dataset.price;
      price.dataset.discounted = option.dataset.discounted;
      panel.querySelector('[data-purchase-compare]').hidden = option.dataset.discounted !== 'true';
      const saving = panel.querySelector('[data-purchase-saving]');
      saving.textContent = option.dataset.saving;
      saving.hidden = !option.dataset.saving;
      panel.querySelector('[data-purchase-saving-every-order]').textContent = option.dataset.savingEveryOrder;
      panel.querySelector('[data-purchase-saving-benefit]').hidden = !option.dataset.savingEveryOrder;
      panel.querySelectorAll('[data-purchase-terms]').forEach((terms) => { terms.hidden = terms.dataset.purchaseTerms !== select.value; });
    }
  }
  customElements.define('cc-purchase-options', PurchaseOptions);
})();
